import React from "react";
import Lastmenu from "./Lastmenu";

const hospitalData = [
  {
    name: "Madhapur",
    address: "#66 , First Floor, Vittal Rao Nagar, Madhapur, Telangana 500081",
    reviews: 2022,
    mapLink: "https://maps.app.goo.gl/8HXtuRQUEE5NzKNT9"
  },
  {
    name: "Miyapur",
    address: "1st Floor, Padma Arcade, opp, IOCL Petrol Pump, ICRISAT Colony, Madeenaguda, Hyderabad, Telangana, 500049",
    reviews: 747,
    mapLink: "https://maps.app.goo.gl/DzckVwkbYVco6wuY9"
  },
  {
    name: "Malakpet",
    address: "16-11-781, Moosarambagh Rd, Saleem Nagar Colony, East Prasanth Nagar, Malakpet, Hyderabad, Telangana, 500036",
    reviews: 879,
    mapLink: "https://maps.app.goo.gl/tSRF8xFtVx7RnyYCA"
  },
  {
    name: "Suchitra",
    address: "2nd Floor, X, Suchitra Rd, above WestSide, near Viva Cafe, Vennala, Gadda, Quthbullapur, Hyderabad, Telangana 500067",
    reviews: 1141,
    mapLink: "https://maps.app.goo.gl/Vg3JY9BjhNaxq2jp7"
  },
  {
    name: "Attapur",
    address: "Pillar No 92, 3rd Floor, 13-6-432/33 & 33/A, above Tata Motors, Attapur, Netaji Nagar Colony, Langar Houz, Hyderabad, Telangana, 500008",
    reviews: 171,
    mapLink: "https://maps.app.goo.gl/2QyNdhiT9FwMntjD7"
  },
  {
    name: "Secunderabad - Opening Soon",
    address: "3rd Floor, MGK Sreekar Building, Mahatma Gandhi Rd, nearby Yamaha Showroom, Rani Gunj, Secunderabad, Telangana 500003",
    reviews: null,
    mapLink: ""
  }
];

const OurHospitals = () => {
  return (
    <>
    <div className="frame1 animated-frame">
      <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px" }}>Our Hospitals</h2>
      <div className="hospital-grid">
        {hospitalData.map((hospital, idx) => (
          <div key={idx} className="hospital-card">
            <h3>{hospital.name}</h3>
            <p>{hospital.address}</p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {hospital.reviews ? (
                <>
                  <p style={{ color: "green", margin: 0 }}>
                    ⭐⭐⭐⭐⭐ ({hospital.reviews} reviews)
                  </p>
                  <button
                    style={{
                      backgroundColor: "#fe5631",
                      color: "#fff",
                      border: "none",
                      borderRadius: "5px",
                      padding: "4px 10px",
                      cursor: "pointer",
                      marginLeft: "10px"
                    }}
                    onClick={() => window.open(hospital.mapLink, "_blank")}
                  >
                    MAP
                  </button>
                </>
              ) : (
                <p style={{ color: "#fe5631", margin: 0 }}>🚧 Opening Soon</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    <Lastmenu />
    </>
  );
};

export default OurHospitals;
